import type { FieldConfig, ValueState } from '../../types'

import { intlFormat } from 'date-fns/intlFormat'

import { Operators } from '../../constants'
import { isObject } from '../../utils/utils'
import FieldController from '../Controller'

export default class DateRangeController extends FieldController {
	constructor(config: FieldConfig) {
		super(config)
		this.getInitialValue = config.getInitialValue || this.getInitialValue
		this.placeholder = config.placeholder || this.placeholder
		this.components = config.components
	}
	components?: any
	placeholder = '__/__/____'

	hasValue = ({ value }: ValueState) =>
		Array.isArray(value) ? value.length > 0 : isObject(value)

	getInitialValue = () => ({
		operation: Operators.DATE_BETWEEN,
		value: [],
	})
	formatState = ({ value }: ValueState) => ({
		operation: '',
		value: `${value?.[0] ? intlFormat(new Date(value[0])) : this.placeholder} - ${value?.[1] ? intlFormat(new Date(value[1])) : this.placeholder}`,
	})
	formatLabel = ({ value }: ValueState) =>
		`${value?.[0] ? intlFormat(new Date(value[0])) : this.placeholder} - ${value?.[1] ? intlFormat(new Date(value[1])) : this.placeholder}`
}
